<h1>Pa&iacute;s: {{ country }}</h1>
<h2>Ciudad: {{ city }}, with calling code: {{ calling_code }}</h2>
<p>Cordenadas: latitud: {{ lat }}, longitud: {{ lng }}</p>

<div class="pinboard">
  <agm-map [latitude]="lat" [longitude]="lng">
    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
  </agm-map>
</div>
